import Head from "next/head";
import { useRouter } from "next/router";

import { useMemo } from "react";

import { twMerge } from "tailwind-merge";

import CustomCard from "components/CustomCard";
import { entityUrl } from "components/EntityPageLayout";
import { useApi } from "hooks/useApi";
import useMediaQuery from "hooks/useMediaQuery";
import shortSecurity from "utils/shortSecurity";

import EntityPageNewsList from "./EntityPageNewsList";
import styles from "./style.module.scss";

type EntityPageNewsProps = {};

const EntityPageNews = ({}: EntityPageNewsProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;

  const { mobile } = useMediaQuery();
  const { data: entity } = useApi(entityUrl(slug));
  const { prettyName: name, security } = entity || {};
  const shortedSecurity = shortSecurity(security);
  const pageTitleName = useMemo(() => {
    if (shortedSecurity) {
      return `${name} | ${shortedSecurity} `;
    }
    return name;
  }, [shortedSecurity, name]);

  const title = `${pageTitleName} - News`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="og:title" content={title} />
      </Head>
      <CustomCard
        className={twMerge(
          styles.card,
          mobile && styles.mobileLayout,
          "mb-0 md:mb-[30px]",
          "min-h-screen"
        )}
      >
        <EntityPageNewsList />
      </CustomCard>
    </>
  );
};

export default EntityPageNews;
